document.addEventListener('DOMContentLoaded', function () {

    const cartToggleButton = document.getElementById('toggleDrawerCart');
    const cartDrawerContent = document.getElementById('drawerContentCart');
    const cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
    const libiHeader = document.querySelector('.libi-header');
    const libiAnnouncementBar = document.getElementById('announcementBar');
    const firstMenuDropDown = document.getElementById('first-menu-dropdown');
    const fristMenuDropDownButton = document.getElementById('first-menu-dropdown-button');
    const secondMenuDropDown = document.getElementById('second-menu-dropdown');
    const secondMenuDropDownButton = document.getElementById('second-menu-dropdown-button');
    const libiHeaderOverlay = document.getElementById('libi-header-overlay');
    const mobileMenuCloseButton = document.getElementById('mobile-menu-close-button');
    const mobileMenuOpenButton = document.getElementById('mobile-menu-open-button');
    const mobileMenu = document.getElementById('mobile-menu');
    const searchToggle = document.getElementById('search-toggle');
    const closeSearchModal = document.getElementById('closeSearchModal');
    const searchModalOverlay = document.getElementById('searchModalOverlay');
    const searchModal = document.querySelector('.header__search');
    const searchInput = document.querySelector('.search__input');
    const openTakeOver = document.getElementById('openTakeOver');

    const takeOver = document.getElementById('takeOver');

    openTakeOver.addEventListener('click', function () {
      takeOver.classList.add('take-over--show');
      document.body.classList.add('is-locked');
    });


    let lastScrollTop = 0;

    searchToggle.addEventListener('click', function() {
      // console.log('click search toggle')
      searchModal.classList.add('header__search--active');
      document.body.classList.add('is-locked');
      searchInput.focus();
    });

    closeSearchModal.addEventListener('click', function() {
      searchModal.classList.remove('header__search--active');
      document.body.classList.remove('is-locked');
    });

    searchModalOverlay.addEventListener('click', function() {
      searchModal.classList.remove('header__search--active');
      document.body.classList.remove('is-locked');
    });



    mobileMenuOpenButton.addEventListener('click', function() {
      mobileMenu.classList.add('mobile-menu--active');
      document.body.classList.add('is-locked');
    });
    mobileMenuCloseButton.addEventListener('click', function() {
      mobileMenu.classList.remove('mobile-menu--active');
      document.body.classList.remove('is-locked');
    });

    // Cart drawer toggle button click handler
    cartToggleButton.addEventListener('click', function() {

      const isExpanded = cartToggleButton.getAttribute('aria-expanded') === 'true';
      cartDrawerOverlay.classList.toggle('cart-drawer-overlay--active')
      cartToggleButton.setAttribute('aria-expanded', !isExpanded);
      cartDrawerContent.setAttribute('aria-hidden', isExpanded ? 'true' : 'false');

      if (!isExpanded) {
        document.addEventListener('keydown', handleEscapeKey);
        document.body.classList.add('is-locked');
        libiHeader.classList.add('drawer-active');
      } else {
        document.body.classList.remove('is-locked');
        document.removeEventListener('keydown', handleEscapeKey);
        libiHeader.classList.remove('drawer-active');
      }
    });

    // Cart drawer overlay click handler
    cartDrawerOverlay.addEventListener('click', function() {
      if (window.location.search.includes("open-cart-drawer=true")) {
        window.location.search = "";
      }

      cartToggleButton.click();
    });

    // Close the cart drawer when the escape key is pressed
    function handleEscapeKey(event) {
      if (event.key === 'Escape') {
        cartToggleButton.click();
      }
    }

    setElementHeight(libiAnnouncementBar, 'announcement-height');

    function updateAnnouncementHeight() {
      setElementHeight(libiAnnouncementBar, 'announcement-height');
    }

    window.addEventListener('resize', updateAnnouncementHeight);

    const debounce = (func, wait) => {
      let timeout;
      return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }

    const handleScroll = () => {
      const header = document.querySelector(".libi-header");
      const announcementBar = document.querySelector(".libi-announcement-bar");

      if (!header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop) {
        // Scrolling down
        header.classList.remove("scroll-up");
        header.classList.add("scroll-down");
        setElementHeight(header, 'header-height');
        announcementBar.classList.remove("scroll-up");
        announcementBar.classList.add("scroll-down");


      } else if (scrollTop < lastScrollTop) {
        // Scrolling up
        header.classList.remove("scroll-down");
        header.classList.add("scroll-up");
        setElementHeight(header, 'header-height');
        announcementBar.classList.remove("scroll-down");
        announcementBar.classList.add("scroll-up");
      }

      // Handle the case when the user is at the top of the page
      if (scrollTop < 1) {
        header.classList.remove("scroll-down", "scroll-up");
        announcementBar.classList.remove("scroll-down", "scroll-up");
      }

      lastScrollTop = scrollTop;
    }

    // Controls the classes for header on scroll
    window.addEventListener("scroll", debounce(handleScroll, 10));

    // Function to add the 'highlight' class to libiHeader
    function addHighlightClass() {
      document.body.classList.add('is-locked');
      libiHeader.classList.add('header-highlight');
      libiAnnouncementBar.classList.add('show-announcement-bar');
    }

    function setElementHeight(element, selector) {
      document.documentElement.style.setProperty(`--${selector}`, `${element.getBoundingClientRect().height - 1}px`);
    }

    // Function to remove the 'highlight' class from libiHeader
    function removeHighlightClass() {
      document.body.classList.remove('is-locked');
      libiHeader.classList.remove('header-highlight');
      libiAnnouncementBar.classList.remove('show-announcement-bar');
    }

    libiHeaderOverlay.addEventListener('click', function() {
      firstMenuDropDown.classList.remove('active');
      secondMenuDropDown.classList.remove('active');
      removeHighlightClass();
    });

    fristMenuDropDownButton.addEventListener('click', function() {
      secondMenuDropDown.classList.remove('active');
      firstMenuDropDown.classList.toggle('active');
      if(firstMenuDropDown.classList.contains('active') || secondMenuDropDown.classList.contains('active')) {
        addHighlightClass();
      } else {
        removeHighlightClass();
      }
    });

    secondMenuDropDownButton.addEventListener('click', function() {
      firstMenuDropDown.classList.remove('active');
      secondMenuDropDown.classList.toggle('active');
      if(firstMenuDropDown.classList.contains('active') || secondMenuDropDown.classList.contains('active')) {
        addHighlightClass();
      } else {
        removeHighlightClass();
      }
    });

});
